import { render, staticRenderFns } from "./ColorBlindness.vue?vue&type=template&id=6e1b6e83&scoped=true&"
import script from "./ColorBlindness.vue?vue&type=script&lang=js&"
export * from "./ColorBlindness.vue?vue&type=script&lang=js&"
import style0 from "./ColorBlindness.vue?vue&type=style&index=0&id=6e1b6e83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1b6e83",
  null
  
)

export default component.exports